import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["value", "changeOnEnd"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { shallowEqual } from '@tencent/glue-util-helper';
import { AxisType, PointType } from '../enum';
import { Region } from './Region';
export var SimpleRegion = /*#__PURE__*/function (_Region) {
  _inherits(SimpleRegion, _Region);

  var _super = _createSuper(SimpleRegion);

  function SimpleRegion() {
    var _this;

    _classCallCheck(this, SimpleRegion);

    _this = _super.call(this);
    _this.isTrying = false;
    _this.changeOnEnd = false;
    _this.value = 0;
    _this.tryingValue = 0;
    _this.old = null;

    _this.createPoint('end', PointType.RIGHT);

    return _this;
  }

  _createClass(SimpleRegion, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      // 增加一个shallowEqual的判断，如果属性不更新没必要update
      if (this.old != null && shallowEqual(this.old, options)) {
        this.old = options;
        return;
      }

      this.old = options;

      var value = options.value,
          _options$changeOnEnd = options.changeOnEnd,
          changeOnEnd = _options$changeOnEnd === void 0 ? false : _options$changeOnEnd,
          config = _objectWithoutProperties(options, _excluded);

      this.changeOnEnd = changeOnEnd;
      this.value = value;
      this.tryingValue = 0;
      this.isTrying = false;
      this.getAxis(AxisType.HORIZONTAL).updateAxisConfig(config);
      this.getPoint('end').updatePointValue();
      this.repaint();
    }
  }, {
    key: "setPointValue",
    value: function setPointValue(part, value, virtual) {
      if (part !== 'end') {
        throw new Error('simple region has only one valid part end');
      }

      if (this.changeOnEnd && virtual) {
        this.tryingValue = value.x;
        this.getPoint('end').repaint();
        return;
      }

      this.emit('change', value.x);
    }
  }, {
    key: "getPointValue",
    value: function getPointValue(part) {
      if (part !== 'end') {
        throw new Error('simple region has only one valid part end');
      }

      return {
        x: this.isTrying ? this.tryingValue : this.value,
        y: 0
      };
    }
  }, {
    key: "isValueSelected",
    value: function isValueSelected(value) {
      return this.isAxisSelected(AxisType.HORIZONTAL, value.x);
    }
  }, {
    key: "isAxisSelected",
    value: function isAxisSelected(type, value) {
      if (type === AxisType.HORIZONTAL) {
        var end = this.isTrying ? this.tryingValue : this.value;
        return value <= end;
      }

      return false;
    }
  }, {
    key: "getPointByOffset",
    value: function getPointByOffset() {
      return this.getPoint('end');
    }
  }, {
    key: "getSelectedRegion",
    value: function getSelectedRegion() {
      return [{
        x: 0,
        y: 0
      }, {
        x: this.isTrying ? this.tryingValue : this.value,
        y: 0
      }];
    }
  }, {
    key: "getSelectedOffset",
    value: function getSelectedOffset() {
      return [{
        x: 0,
        y: 0
      }, {
        x: this.getPoint('end').getOffset().x,
        y: 0
      }];
    }
  }]);

  return SimpleRegion;
}(Region);